import {Record, List, Map as IMap} from 'immutable';
import type {RecordOf} from 'immutable';
import type {FieldType as Field} from '@packages/systems/dynamo/records/Field';
import type {FieldGroupType} from '@packages/systems/dynamo/records/FieldGroup';

export type CollectionRecordProps = {
  _id: string;
  slug: string | null;
  name: string;
  createdOn: Date | null;
  lastUpdated: Date | null;
  pluralName: string;
  singularName: string;
  plugin: string;
  fields: List<Field>;
  fieldGroups: List<FieldGroupType>;
  itemCount: number;
  sortPos: number;
  localizedSettings?: CollectionLocalizedSettings;
};

const defaultCollectionRecordProps: CollectionRecordProps = {
  // @ts-expect-error _id is typed as string!
  _id: null as string,
  // Note we no longer need as casting for slug, createdOn or lastUpdated
  slug: null,
  name: '',
  createdOn: null,
  lastUpdated: null,
  pluralName: 'Items',
  singularName: 'Item',
  plugin: 'cms',
  fields: List(),
  fieldGroups: List(),
  itemCount: 0,
  sortPos: 0,
  // Note that we no longer need to generics for localizedSettings
  localizedSettings: IMap(),
};

const CollectionRecord: Record.Factory<CollectionRecordProps> = Record(
  defaultCollectionRecordProps,
  'CollectionRecord'
);

export type Collections = IMap<string, CollectionRecordType>;
export type CollectionRecordType = RecordOf<CollectionRecordProps>;

export type CollectionLocalizedSettings = IMap<
  // locale id
  string,
  CollectionLocalizedSettingsForLocale
>;

// settings object, e.g. { slug: 'some-slug', … }
export type CollectionLocalizedSettingsForLocale = IMap<string, any>;

export default CollectionRecord;
